export const SET_COMPETITION_ID = "SET_COMPETITION_ID";
